import { Location } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-layout-noframe',
  templateUrl: './noframe.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class LayoutNoframeComponent { }
